import { render } from "./RequestApproval.vue?vue&type=template&id=461e9888&scoped=true"
import script from "./RequestApproval.vue?vue&type=script&lang=js"
export * from "./RequestApproval.vue?vue&type=script&lang=js"

import "./RequestApproval.vue?vue&type=style&index=0&id=461e9888&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-461e9888"]])

export default __exports__